import { render } from "./ConversationThreadItem.vue?vue&type=template&id=9450c5b4"
import script from "./ConversationThreadItem.vue?vue&type=script&lang=js"
export * from "./ConversationThreadItem.vue?vue&type=script&lang=js"
script.render = render

export default script